export const TIER_DEFAULTS = {
  basic: { // aka free
    maxReports: 3,
    maxExpensesPerReport: 50,
    scansPerMonth: 5,
    imageStorage: false,
    exportFormats: ['csv'],
    canCombineReports: false,
    canShare: false,
    canShareEdit: false,
    maxCollaborators: 0,
    customCategories: false,
    groupBy: false,
    taxReport: false,
    auditTrail: false,
    aiReconcile: false,
    aiBookkeeper: false,
    aiContextLen: 1500,
    aiQueriesPerWeek: 5,
    aiTokensInPerWeek: 5000,
    aiTokensOutPerWeek: 1000,
    aiToolCallsPerWeek: 20,
    aiToolCallsPerMonth: 60,
  },
  starter: { // aka standard
    maxReports: 20,
    maxExpensesPerReport: -1,
    scansPerMonth: 30,
    imageStorage: true,
    exportFormats: ['csv', 'xlsx', 'json', 'pdf'],
    canCombineReports: true,
    canShare: true,
    canShareEdit: false,
    maxCollaborators: 2,
    customCategories: true,
    groupBy: true,
    taxReport: false,
    auditTrail: false,
    aiReconcile: false,
    aiBookkeeper: true,
    aiContextLen: 3000,
    aiQueriesPerWeek: -1,
    aiTokensInPerWeek: 500000,
    aiTokensOutPerWeek: 30000,
    aiToolCallsPerWeek: 500,
    aiToolCallsPerMonth: 2000,
  },
  pro: {
    maxReports: -1,
    maxExpensesPerReport: -1,
    scansPerMonth: 150,
    imageStorage: true,
    exportFormats: ['csv', 'xlsx', 'json', 'doc', 'taxreport', 'pdf'],
    canCombineReports: true,
    canShare: true,
    canShareEdit: true,
    maxCollaborators: 10,
    customCategories: true,
    groupBy: true,
    taxReport: true,
    auditTrail: true,
    aiReconcile: true,
    aiBookkeeper: true,
    aiContextLen: 6000,
    aiQueriesPerWeek: -1,
    aiTokensInPerWeek: 2000000,
    aiTokensOutPerWeek: 100000,
    aiToolCallsPerWeek: 10000,
    aiToolCallsPerMonth: 50000,
  },
};

export const TIER_NAMES  = { basic: 'Free', starter: 'Standard', pro: 'Pro' };
export const TIER_PRICES = { basic: 'Free', starter: '$2.99/mo', pro: '$6.99/mo' };
export const TIER_ORDER  = ['basic', 'starter', 'pro'];
export const DEFAULT_TIER = 'basic';
